export default __webpack_public_path__ + "static/media/platform_background_right.d4d32c42.png";